<template>
  <div v-if="!logado"></div>
  <router-view v-else></router-view>
</template>

<script>
export default {
  name: 'Tarefas',
  data () {
    return {
      logado: false,
      ok: true
    }
  },
  created: function () {
    this.logado = this.$root.auth
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Tarefas.vue